import { forwardRef, memo } from 'react';
import React from 'react';
import { classNames } from '../../utils/classNames';
import type { HTMLAttributes, CSSProperties } from 'react';

interface LoadingStateProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'style'> {
  className?: string;
  styleOverrides?: CSSProperties;
}

const LoadingStateComponent = forwardRef<HTMLDivElement, LoadingStateProps>(
  ({ className, styleOverrides, ...restProps }, ref) => {
    return (
      <div
        ref={ref}
        className={classNames(
          'comment-list',
          'comment-list--loading',
          className
        )}
        style={styleOverrides}
        {...restProps}
      >
        <div className="comment-list__loading">Loading comments...</div>
      </div>
    );
  }
);

LoadingStateComponent.displayName = 'LoadingState';

export const LoadingState = memo(LoadingStateComponent);
